import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const Dashboard = lazy(() => import('@/pages/Dashboard'));
const NotificationListPage = lazy(() => import('@/pages/NotificationListPage'));
const MyPage = lazy(() => import('@/pages/mypage/MyPage'));
const ComingSoonPage = lazy(() => import('@/pages/ComingSoonPage'));

/** 모듈에 속하지 않는 공통 라우트 (대시보드 / 알림 / My Page) */
const commonRoutes = [
  <Route key="index" index element={<Navigate to="/dashboard" replace />} />,
  <Route key="dashboard" path="dashboard" element={<Dashboard />} />,
  <Route key="notifications" path="notifications" element={<NotificationListPage />} />,

  // My Page — 개인정보 / 참여 프로젝트 / 내 업무 / 내 결재 / 내 연차 / 결재 서명
  <Route key="mypage" path="mypage" element={<MyPage />} />,
  // 기존 경로는 My Page 로 넘긴다(북마크·알림 링크 보존)
  <Route key="hr-profile" path="hr/profile" element={<Navigate to="/mypage" replace />} />,

  // 직원관리·조직도는 hrRoutes 에 있다.

  // 준비 중 화면 (하위 대시보드 경로)
  <Route key="dashboard-wildcard" path="dashboard/*" element={<ComingSoonPage />} />,
];

export default commonRoutes;
